import { render } from "./MediaForm.vue?vue&type=template&id=0413a406&scoped=true"
import script from "./MediaForm.vue?vue&type=script&lang=js"
export * from "./MediaForm.vue?vue&type=script&lang=js"

import "./MediaForm.vue?vue&type=style&index=0&id=0413a406&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0413a406"]])

export default __exports__